import { translateStatus } from './statusTranslations';

export const isInvoicePriceHigher = (invoice, approvalPackage) => {
  return !!(invoice?.errorDetails || approvalPackage?.invoiceId?.errorDetails);
};

export const determineInvoiceStatus = (invoice, approvalPackage) => {
  let status = invoice?.status || approvalPackage?.status;
  
  if (status === 'approved' || status === 'APPROVED' || 
      status === 'מאושר' || approvalPackage?.status === 'approved') {
    return 'מאושר';
  }
  
  if (status === 'rejected' || status === 'REJECTED' ||
      status === 'נדחה' || approvalPackage?.status === 'rejected') {
    return 'נדחה';
  }
  
  if (status === 'PENDING_APPROVAL' || status === 'pending_approval' || 
      status === 'ממתין לאישור') {
    if (invoice?.errorDetails || approvalPackage?.invoiceId?.errorDetails) {
      return 'חשבונית להמשך טיפול';
    } else {
      return 'ממתין לאישור';
    }
  }
  
  if (status?.includes('pending_priority') || 
      status?.includes('PENDING_PRIORITY') ||
      status?.includes('ממתין ליצירה')) {
    return 'ממתין ליצירה בפריוריטי';
  }

  return translateStatus(status);
};

export const syncAllInvoiceStatuses = (queryClient) => {
  queryClient.invalidateQueries(['approvalPackages']);
  queryClient.invalidateQueries(['spInvoices']);
  const statusChangeEvent = new CustomEvent('invoice-status-changed', {
    detail: { timestamp: new Date().getTime() }
  });
  window.dispatchEvent(statusChangeEvent);
};